import { render, staticRenderFns } from "./SaleReport.vue?vue&type=template&id=4f570137&"
import script from "./SaleReport.vue?vue&type=script&lang=js&"
export * from "./SaleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports